/*
 * @Description:
 * @Date: 2020-01-06 13:20:49
 */
import searchFilter from './searchFields';
import { $$Seat } from './tool';
const map = {
  '1_0': [
    // '任务月度$$R_1=["药店名称","医疗机构"]',
    '任务月度',
    '时间区间',
    '项目参与人',
    '手机号',
    '医院',
    '审核状态'
  ], // 学术-记录
  '1_1': ['任务月度', '项目参与人', '手机号', '任务完成率'], // 学术-汇总
  '9_0': [
    '任务月度',
    '时间区间',
    '项目参与人',
    '手机号',
    '医院',
    { tip: '客户姓名', key: 'customerName', slot: 'input' },
    ,
    '审核状态'
  ], // 等级医院拜访-记录
  '9_1': ['任务月度', '项目参与人', '手机号', '任务完成率'], // 等级医院拜访-汇总
  '10_0': [
    '任务月度',
    '时间区间',
    '项目参与人',
    '手机号',
    '医疗机构',
    { tip: '客户姓名', key: 'customerName', slot: 'input' },
    '审核状态'
  ], // 基层医疗机构拜访-记录
  '10_1': ['任务月度', '项目参与人', '手机号', '任务完成率'], // 基层医疗机构拜访-汇总
  '2_0': ['任务月度', '项目参与人', '手机号', '药店名称', '审核状态'], // OTC拜访-记录
  '2_1': ['任务月度', '项目参与人', '手机号', '任务完成率'], // OTC拜访-汇总
  '5_0': [
    '任务月度',
    '项目参与人',
    '手机号',
    { tip: '问卷编号', key: 'taskCode', slot: 'input' },
    '审核状态'
  ], // 患者调研-记录
  '5_1': ['任务月度', '项目参与人', '手机号', '任务完成率'], // 患者调研-汇总
  '3_0': ['任务月度', '项目参与人', '手机号', '医院', '审核状态'], // 科室会-记录
  '3_1': ['任务月度', '项目参与人', '手机号', '任务完成率'], // 科室会-汇总
  '4_0': ['任务月度', '项目参与人', '手机号', '会议地址', '审核状态'], // 患教会-记录
  '4_1': ['任务月度', '项目参与人', '手机号', '任务完成率'], // 患教会-汇总
  '6_0': ['任务月度', '项目参与人', '手机号'], // 线上推广-记录
  '6_1': ['任务月度', '项目参与人', '手机号', '任务完成率 '], // 线上推广-汇总
  '11_0': ['任务月度', '项目参与人', '手机号', '医院', '审核状态'], // 特级三甲医院市场准入-记录
  '11_1': ['任务月度', '项目参与人', '手机号'], // 特级三甲医院市场准入-汇总
  '12_0': ['任务月度', '项目参与人', '手机号', '医院', '审核状态'], // 三级医院市场准入-记录
  '12_1': ['任务月度', '项目参与人', '手机号'], // 三级医院市场准入-汇总
  '13_0': ['任务月度', '项目参与人', '手机号', '医院', '审核状态'], // 二级医院市场准入-记录
  '13_1': ['任务月度', '项目参与人', '手机号'], // 三级医院市场准入-汇总
  '14_0': ['任务月度', '项目参与人', '手机号', '机构', '审核状态'], // 基层医疗机构市场准入-记录
  '14_1': ['任务月度', '项目参与人', '手机号'], // 基层医疗机构市场准入-汇总
  '15_0': ['任务月度', '项目参与人', '手机号', '药店', '审核状态'], // 零售药店市场准入-记录
  '15_1': ['任务月度', '项目参与人', '手机号'], // 零售药店市场准入-汇总
  '7_0': [
    '任务月度',
    '项目参与人',
    '手机号',
    { tip: '问卷编号', key: 'taskCode', slot: 'input' },
    '审核状态'
  ], // 医学调研-记录
  '7_1': ['任务月度', '项目参与人', '手机号', '任务完成率'], // 医学调研-汇总
  '8_0': ['任务月度', '项目参与人', '手机号', '审核状态'], // 医学病例收集-记录
  '8_1': ['任务月度', '项目参与人', '手机号', '任务完成率'], // 医学病例收集-汇总
  '18_0': ['任务月度', '项目参与人', '手机号', '审核状态'], // 病例收集-记录
  '18_1': ['任务月度', '项目参与人', '手机号', '任务完成率'], // 病例收集-汇总
  '17_1': ['任务月度', '项目参与人', '手机号', '任务完成率'],
  '17_0': ['任务月度', '项目参与人', '手机号', '审核状态'],
  '19_0': [
    '任务月度',
    '项目参与人',
    '手机号',
    '签约状态',
    {
      tip: '审核状态',
      use: [2],
      key: 'authStatus',
      // 选项数据
      options: [
        {
          name: '全部',
          key: ''
        },
        {
          name: '审核中',
          key: 1
        },
        {
          name: '审核通过',
          key: 2
        },
        {
          name: '审核不通过',
          key: 3
        },
        {
          name: '任务失效',
          key: 4
        }
      ],
      slot: 'select'
    },
    '结算状态'
  ],
  '19_1': ['任务月度', '项目参与人', '手机号'],
  '20_0': [
    '任务月度',
    '项目参与人',
    '手机号',
    '任务编码',
    {
      tip: '审核状态',
      key: 'authStatus',
      // 选项数据
      options: [
        {
          name: '全部',
          key: ''
        },
        {
          name: '审核中',
          key: 1
        },
        {
          name: '审核通过',
          key: 2
        },
        {
          name: '审核不通过',
          key: 3
        },
        {
          name: '任务失效',
          key: 4
        }
      ],
      slot: 'select'
    }
  ],
  '20_1': ['任务月度', '项目参与人', '手机号']
};
/**
 * @description: 搜索对应字段
 * @param {string, number}  type 项目类型_index(0|1) taxCollectionPattern
 * @return: searchFilter(copy)
 */
export default function(type, taxCollectionPattern) {
  let copy = map[type] ? [...map[type]] : null;
  //  if(copy){
  //    copy.unshift('运营编码')
  //  }
  if (taxCollectionPattern === 5) {
    copy.forEach((item, index) => {
      if (item == '项目参与人') {
        copy[index] = `${item}$$R_${taxCollectionPattern}=["经营者","个体"]`;
      }
    });
  }
  if (taxCollectionPattern === 9) {
    copy.forEach((item, index) => {
      if (item == '项目参与人') {
        copy[
          index
        ] = `${item}$$R_${taxCollectionPattern}=["项目参与人","个体"]`;
      }
    });
  }
  if (copy) {
    let seat = $$Seat(copy, taxCollectionPattern);
    return searchFilter(seat);
  }
  return null;
}
